import api from './api';

export const permissionService = {
  getAll: async () => {
    const response = await api.get('/permissions');
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/permissions/${id}`);
    return response.data;
  },

  getModules: async () => {
    const response = await api.get('/permissions/modules');
    return response.data;
  },
};

export default permissionService;
